import { useContext } from 'react'
import { AuthContext } from '@/types/authContext.type'

/**
 * Hook to access authentication context
 * Moved to separate file to fix Fast Refresh issue
 */
export function useAuth() {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
